import { Component, Input, OnInit } from '@angular/core';
import { MovimientoCuentaModeloMSL } from '../../../open-api';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import html2canvas from 'html2canvas';
@Component({
  selector: 'app-estado-cuenta',
  templateUrl: './estado-cuenta.component.html',
  styleUrls: ['./estado-cuenta.component.scss']
})
export class EstadoCuentaComponent implements OnInit {
  @Input() movimientos?: MovimientoCuentaModeloMSL[];
  constructor(private spinner: NgxSpinnerService,
    public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }
  CerrarModal(): void {
    this.activeModal.close();
  }
  Descargar() {
    this.spinner.show();
    const doc = new jsPDF('p', 'mm', 'a4');
    const htmlDoc = document.getElementById('save-pdf') || new HTMLElement();
    const icon = htmlDoc.getElementsByClassName('material-icons')[0];
    icon?.remove();

    const image = document.getElementById('logo') || new HTMLElement();
    image.style.display = 'block';
    image.style.marginLeft = 'auto';
    image.style.marginRight = 'auto';
    image.style.alignItems = 'center';
    image.style.width = '500px';

    doc.html(htmlDoc?.innerHTML || '', {
      callback: (doc) => {
        doc.save('Comprobante.pdf');
        this.spinner.hide();
      },
      width: 170,
      windowWidth: 700,
      autoPaging: true,
      x: 10,
      y: 10,
    });
  }

}
